(() => {
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#merino-"]');
      if (!link) return;
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
      target.scrollIntoView({behavior: reduce ? 'instant' : 'smooth', block: 'start'});
      history.replaceState(null, '', link.getAttribute('href'));
    });
    if (!reduce && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('tm-waiting');
            observer.unobserve(entry.target);
          }
        });
      }, {threshold: 0.04});
      root.querySelectorAll('[data-merino-reveal]').forEach((el) => {
        if (el.getBoundingClientRect().top > innerHeight) {
          el.classList.add('tm-waiting');
          observer.observe(el);
        }
      });
      setTimeout(() => root.querySelectorAll('.tm-waiting').forEach(el => el.classList.remove('tm-waiting')), 6000);
    }
  };
  document.querySelectorAll('[data-merino]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-merino]')));
})();
